module.exports = __webpack_public_path__ + "mainassets/img/logo.8140de9d.jpg";